import { RoundedFilledButton } from '@/components/buttons/Buttons';
import { CustomSlider } from '@/components/slider/CustomSlider';
import { HorizontalDivider } from '@/components/utils/Divider';
import { Sidebar } from 'primereact/sidebar';
import {
	MdCheckBox,
	MdCheckBoxOutlineBlank,
	MdClose,
	MdOutlineRadioButtonUnchecked,
	MdRadioButtonChecked,
} from 'react-icons/md';
import styles from './filter-panel.module.css';
import { UseQueryResult } from '@tanstack/react-query';
import { ListResponse } from '@/common/common_utils';
import { CenterContent } from '@/components/container/Container';
import Spinner from '@/components/utils/Spinner';
import { X4bProgramDto } from '@/modules/vehicle/engine/ActivityTypes';

type FilterPanelProps = {
	show: boolean;
	onFilterClear: () => void;
	onClose: () => void;
	statusList: string[];
	statusSelected?: string | null;
	setStatusSelected: (value: string) => void;
	programsCheckedIds?: number[] | null;
	handleProgramCheckboxChange: (id: number) => void;
	filterList?: string[];
	setSideFilter: (value: string[]) => void;
	programsQ: UseQueryResult<ListResponse<X4bProgramDto>>;
	amount?: number | null;
	onAmountChange: (am: number) => void;
};

const FilterPanel = ({
	show,
	onClose,
	onFilterClear,
	statusList,
	statusSelected: selected,
	setStatusSelected: setStatusSelected,
	programsCheckedIds: checkedIds,
	handleProgramCheckboxChange,
	setSideFilter: setSideFilter,
	programsQ,
	amount,
	onAmountChange
}: FilterPanelProps) => {


	return (
		<>
			{programsQ.isLoading ? (
				<CenterContent>
					<Spinner />
				</CenterContent>
			) : (
				<Sidebar
					visible={show}
					onHide={onClose}
					position="right"
					className={styles.sidebarStyle}
					maskClassName={styles.customMask}
					content={() => (
						<div className={styles.panelContainer}>
							<div className={styles.sidebarContent}>
								<div className={styles.header}>
									<h3 className={styles.headerTitle}>Filters</h3>
									<button
										type="button"
										onClick={onClose}
										className={styles.closeButton}
										aria-label="Close"
									>
										<MdClose
											className="text-onSurfaceVariant"
											size={24}
										/>
									</button>
								</div>

								<div className="mx-[18px]">
									<p className={styles.sectionTitle}>Status</p>
									<div
										role="radiogroup"
										className={styles.radioGroup}
									>
										{statusList.map((status) => (
											<label
												key={status}
												className={styles.radioLabel}
											>
												<input
													type="radio"
													name="status"
													value={status}
													checked={selected === status}
													onChange={() => setStatusSelected(status)}
													className="hidden"
												/>
												{selected === status ? (
													<MdRadioButtonChecked className="w-6 h-6 text-primary" />
												) : (
													<MdOutlineRadioButtonUnchecked className="w-6 h-6 text-onSurfaceVariant" />
												)}
												<span className={styles.radioText}>
													{status === 'OnTrip'
														? 'On Trip' : status}
												</span>
											</label>
										))}
									</div>
								</div>

								<div className="mx-[18px]">
									<p className={styles.sectionTitle}>Program</p>
									<div className={styles.checkboxGroup}>
										{programsQ.data?.Items.map((program) => (
											<label
												key={program.Id}
												className={styles.checkboxLabel}
											>
												<input
													type="checkbox"
													value={program.Id}
													checked={checkedIds && checkedIds.includes(program.Id) || undefined}

													onChange={() => handleProgramCheckboxChange(program.Id)}
													className="hidden"
												/>
												{checkedIds && checkedIds.includes(program.Id) ? (
													<MdCheckBox
														className={
															styles.checkboxIconChecked
														}
													/>
												) : (
													<MdCheckBoxOutlineBlank
														className={
															styles.checkboxIconUnchecked
														}
													/>
												)}
												<span className={styles.checkboxText}>
													{program.Name}
												</span>
											</label>
										))}
									</div>
								</div>

								<div className="mx-[18px]">
									<p className={styles.sectionTitle}>Amount</p>
									{/* TODO[Phase2]: what should be the max value here? */}
									<CustomSlider value={amount || undefined} min={0} max={400} onChange={onAmountChange} />
								</div>
							</div>

							<div className="flex flex-col">
								<HorizontalDivider />

								<div className={styles.buttonContainer}>
									<RoundedFilledButton
										id="apply"
										className={`${styles.applyButton} h-10`}
										// Currently these button are not used - we apply filter immmediately. Let's wait for feedback and may be remove the buttons.
										label="Apply"
										width="89px"
										onClick={() => {
											// setSideFilter([
											// 	'Completed',
											// 	'Travel Program',
											// 	'10',
											// ]);
											onClose();
										}}
									/>
									<RoundedFilledButton
										id="cancel"
										className={`${styles.cancelButton} h-10`}
										label="Cancel"
										width="99px"
										onClick={() => {
											onFilterClear();
											onClose();
										}}
									/>
								</div>
							</div>
						</div>
					)}
				/>
			)}

		</>
	);
};

export default FilterPanel;
